import { Box, Divider, Stack, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import DateFnsAdapter from '@date-io/date-fns';

import {
    AppFormikTextArea,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const dateFns = new DateFnsAdapter();

const LeftMenu: React.FC<LeftMenuProps> = (props): ReactElement => {
    const { solicitor, expirityDate, documents, onClickViewDocument } = props;
    return (
        <Box className="menu-wrapper">
            <Box className="menu-container">
                {/* <Typography variant="h3">Re-work Cross check</Typography> */}
                <Stack direction="column" className="menu">
                    <Box className="menu-content">
                        <Typography variant="h4">Loanwriter</Typography>
                        <Typography className="solicitorName">
                            {solicitor}
                        </Typography>
                    </Box>
                    <Box className="menu-content">
                        <Typography variant="h4">Expiry Date</Typography>
                        <Typography>
                            {`${dateFns.format(
                                expirityDate,
                                'normalDate'
                            )} ${dateFns.format(expirityDate, 'year')}`}
                        </Typography>
                    </Box>
                    <Divider />
                    <Box className="menu-content content-message">
                        <Typography>
                            Please re-upload the documents listed below:
                        </Typography>
                        <br />
                        {documents &&
                            documents.map((element, index) => (
                                <Stack direction="row">
                                    <FiberManualRecordIcon fontSize="small" />
                                    <Box
                                        key={index}
                                        className="content-rework-document"
                                    >
                                        <Typography
                                            className={
                                                element.isMissingDocument
                                                    ? 'missing-doc'
                                                    : 'placeholder'
                                            }
                                        >
                                            {element.placeholder}
                                        </Typography>
                                        <AppFormikTextArea
                                            name={`comments[${index}]`}
                                            fullWidth
                                            placeholder="Enter a comment"
                                        />
                                        {element.isMissingDocument ===
                                            false && (
                                            <AppPrimaryButton
                                                onClick={() =>
                                                    onClickViewDocument(index)
                                                }
                                                title="View Document"
                                                aria-haspopup="dialog"
                                                loadingSize={22}
                                                loadingText="PROCESSING"
                                                className="btn-small download"
                                            />
                                        )}
                                    </Box>
                                </Stack>
                            ))}
                    </Box>
                </Stack>
            </Box>
            <Box className="menu-footer">
                <img
                    className="app-logo"
                    src="/images/brand/Pepper-mono-logo.svg"
                    width={236}
                    height={30}
                />
            </Box>
        </Box>
    );
};

export default LeftMenu;
